// src/App.tsx
// Aplikasi utama dengan routing


import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ProfileDetailPage from './pages/ProfileDetailPage';
import ContactPage from './pages/ContactPage';
import { AdminRoutes } from './components/admin/AdminRoutes';
import { ToastProvider } from './components/admin/Toast';
import { PhotoProvider } from 'react-photo-view';
import { useAnalytics } from './hooks/useAnalytics';
import 'react-photo-view/dist/react-photo-view.css';
import './App.css';

// Component that uses analytics inside Router context
function AppContent() {
  // Initialize analytics tracking for visitors
  useAnalytics();

  return (
    <div className="App min-h-screen bg-white">
      <Routes>
        {/* Portfolio routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/profile" element={<ProfileDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Halaman worksheet disembunyikan (redirect ke Beranda) */}
        <Route path="/worksheet" element={<Navigate to="/" replace />} />
        
        {/* Admin routes */}
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <PhotoProvider>
        <Router>
          <AppContent />
        </Router>
      </PhotoProvider>
    </ToastProvider>
  );
}

export default App;